import React, { useState } from "react";
import { axiosPrivate } from "../../api/axios";
import { useNavigate, useLocation } from "react-router-dom";

const SendNotification = () => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [targetType, setTargetType] = useState("all");
  const [emails, setEmails] = useState("");
  const [icon, setIcon] = useState("");
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    setError(null);

    try {
      const emailArray = targetType === "specific"
        ? emails.split(",").map(email => email.trim()).filter(email => email)
        : [];

      const payload = {
        title,
        body,
        targetType,
        emails: emailArray,
      };

      // Only include icon if it's provided
      if (icon && icon.trim()) {
        payload.icon = icon.trim();
      }

      // Only include URL if it's provided
      if (url && url.trim()) {
        payload.url = url.trim();
      }

      const response = await axiosPrivate.post("/admin/send-notification", payload);

      setMessage(response.data.message);
      // Reset form on success
      setTitle("");
      setBody("");
      setEmails("");
      setIcon("");
      setUrl("");
    } catch (err) {
      console.error(err);
      if (err.response?.status === 403) {
        navigate("/login", { state: { from: location }, replace: true });
      } else {
        setError(err.response?.data?.message || "Failed to send notification");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Send Push Notification</h1>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="title" className="block text-sm font-medium mb-2">
            Title
          </label>
          <input
            type="text"
            id="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Notification title"
          />
        </div>

        <div>
          <label htmlFor="body" className="block text-sm font-medium mb-2">
            Message
          </label>
          <textarea
            id="body"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            required
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Notification message"
          />
        </div>

        <div>
          <label htmlFor="icon" className="block text-sm font-medium mb-2">
            Icon URL (optional)
          </label>
          <input
            type="url"
            id="icon"
            value={icon}
            onChange={(e) => setIcon(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="https://example.com/icon.png"
          />
          <p className="text-sm text-gray-500 mt-1">
            Leave empty to send notification without an icon
          </p>
        </div>

        <div>
          <label htmlFor="url" className="block text-sm font-medium mb-2">
            Click URL (optional)
          </label>
          <input
            type="url"
            id="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="https://mysolon.gr/some-page"
          />
          <p className="text-sm text-gray-500 mt-1">
            URL to open when user clicks the notification
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">
            Send To
          </label>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="radio"
                name="targetType"
                value="all"
                checked={targetType === "all"}
                onChange={(e) => setTargetType(e.target.value)}
                className="mr-2"
              />
              All Users
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="targetType"
                value="specific"
                checked={targetType === "specific"}
                onChange={(e) => setTargetType(e.target.value)}
                className="mr-2"
              />
              Specific Users (by email)
            </label>
          </div>
        </div>

        {targetType === "specific" && (
          <div>
            <label htmlFor="emails" className="block text-sm font-medium mb-2">
              Email Addresses (comma-separated)
            </label>
            <textarea
              id="emails"
              value={emails}
              onChange={(e) => setEmails(e.target.value)}
              required
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="email1@example.com, email2@example.com"
            />
            <p className="text-sm text-gray-500 mt-1">
              Enter email addresses separated by commas
            </p>
          </div>
        )}

        {message && (
          <div className="p-4 bg-green-100 border border-green-400 text-green-700 rounded">
            {message}
          </div>
        )}

        {error && (
          <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Sending..." : "Send Notification"}
        </button>
      </form>
    </div>
  );
};

export default SendNotification;
